/**
 * shared/credential-append-copy.ts
 *
 * Stage 7 "passkey boundary gaps", module 01, Task 2 (AC-1), fix round 2
 * (ruling S7-19). Relocated out of
 * `server/logic/security-tier-ladder/credential-append-notice.ts` so the
 * client (Task 3) never has to import a server module to render the same
 * strings.
 *
 * The single source for both audiences' copy (Ruling S7-5), consumed by the
 * server's WS fan-out (`credential-append-notice.ts`), its durable feed
 * source (`sources-credential-append.ts`), and the client's notification
 * row — so the WS message, the pull-based feed, and any client-rendered
 * string can never drift apart. `owner` carries NO device name —
 * `notifyCredentialAppended` inserts the ` (deviceName)` parenthetical
 * itself when one is known.
 *
 * `linkLabel` (Round-1 review, #3169 Minor 8) is the ONE call-to-action
 * string shared by both surfaces that can follow a link to this notice: the
 * durable notifications-feed row (`notification-row.tsx`'s `KIND_CTA_LABEL`)
 * and the live WS toast (`credential-added-push-listener.tsx`) — so the two
 * can never drift to different wording for the same action.
 */
export const CREDENTIAL_ADDED_COPY = {
  owner:
    "A new passkey was added to your account. If this wasn't you, remove it from Security Keys.",
  guardian:
    "A new passkey was added to an account you protect. There is nothing to approve — check with them directly if it seems wrong.",
  linkLabel: "Review passkeys",
} as const;
